import type { SvgIconProps } from '@lokalise/louis';
import { SvgIcon } from '@lokalise/louis';

const ThumbDown = ({ ...props }: SvgIconProps) => (
    <SvgIcon {...props}>
        <path d="M17.1818 12.0119V0.0119076L20 0V12L17.1818 12.0119ZM13.3636 0.0119076C13.87 0.0119076 14.3555 0.240278 14.7136 0.614789C15.0716 0.9893 15.2727 1.49725 15.2727 2.02688V12.0119C15.2727 12.5611 15.0627 13.0603 14.7095 13.4198L8.42864 19.9999L7.41682 18.9415C7.15909 18.6719 6.99682 18.3025 6.99682 17.8831L7.02545 17.5736L7.93227 13.0104H1.90909C0.849545 13.0104 0 12.1118 0 11.0134V9.0164C0 8.75679 0.0477272 8.51715 0.133636 8.28749L3.01636 1.24805C3.30273 0.529131 3.98045 0.0119076 4.77273 0.0119076H13.3636ZM13.3636 2.02688H4.74409L1.90909 9.0164V11.0134H10.29L9.21136 16.3254L13.3636 11.982V2.02688Z" />
    </SvgIcon>
);

export default ThumbDown;
